// Copyright (c) 2025-2026 Motswagae Holding (Pty) Ltd. All Rights Reserved.
// CIPC Registration: 2019/443098/07
// Author: Velly Sipho Phaloane
//
// This source code is the proprietary and confidential property of
// Motswagae Holding (Pty) Ltd, trading as 360Wallet.
// Unauthorized copying, modification, distribution, or use of this
// software, in whole or in part, is strictly prohibited.
//
// Protected under the Copyright Act 98 of 1978 (South Africa)
// and international copyright treaties.
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
